<template>
    <div>
        <div class="mt-5">
            <settings-edit />
        </div>
    </div>
</template>

<script>
import SettingsEdit from './SettingsEdit';

export default {
    data() {
        return {
        };
    },
    mounted() {},
    methods: {},
    components: {
        SettingsEdit
    }
};
</script>
